export const DOCS_URL = 'https://docs.xemex-cloud.eu';
